import { getReq, postReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel } from "@/models/core.model";
import { jsonFromStoryChapterTask, SpecificType, StoryChapterTask, storyChapterTaskFromJson, StoryChapterTaskPaginationFilterRequest, UpsertSpecificType, UpsertStoryChapterTask } from "@/models/story-chapter-task.model";


export const getPagedMainStoryChapterTasks = async (input: StoryChapterTaskPaginationFilterRequest): Promise<PagedResponseModel<StoryChapterTask>> => {
  return await getReq(createUrl("a/Story/Chapter/Task/PagedData"),
    { params: input }
  ).then((res: any) => ({
    ...res.data,
    result: res.data.result.map(itm => storyChapterTaskFromJson(itm))
  }));
};

export const getStoryChapterTask = async (id: number): Promise<BaseResponseModel<StoryChapterTask&SpecificType>> => {
  return await getReq(createUrl(`a/Story/Chapter/Task/GetById/${id}`),
  ).then((res: any) => ({
    ...res.data,
    result: storyChapterTaskFromJson(res.data.result)
  }));
};

export const upsertStoryChapterTask = async (input: UpsertStoryChapterTask & UpsertSpecificType): Promise<BaseResponseModel<null>> => {
  return await postReq(createUrl("a/Story/Chapter/Task/Upsert"),
    jsonFromStoryChapterTask(input)
  ).then((res: any) => res.data);
};
